module.exports = __webpack_public_path__ + "static/estados-b32855513230226910b8263a9ba59e65.pdf";